export function MySpotIqSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/my-spot-iq.svg'"></ng-include>`
    }
}